<template>
  <div class="flex-col login-info">
    <div class="title">登录</div>
    <div class="flex-col"
      style="padding: 70px 0;">
      <form action="">
        <div class="flex-col">
          <!-- guid -->
          <div class="flex-col line-info">
            <div class="flex-row type-left">
              <label class="must-label">GUID</label> <i class="must-input">* </i>
            </div>
            <div class="flex-col red-bg"
              style="padding: 0 1rem;">
              <input class="input-style"
                type="text"
                ref="username"
                v-model="loginInfo.userName"
                autocomplete="off"
                :placeholder="$t('common.guidTips')">
            </div>
          </div>

          <!-- 密码 -->
          <div class="flex-col line-info">
            <div class="flex-row type-left">
              <label class="must-label">密码 </label> <i class="must-input">* </i>
            </div>
            <div class="flex-col"
              style="padding: 0 1rem;">
              <input class="input-style"
                type="password"
                ref="password"
                v-model="loginInfo.password"
                autocomplete="off"
                :placeholder="$t('common.passwordTips')">
            </div>
          </div>
        </div>
      </form>
      <div class="submit-button">
        <van-button round
          block
          type="info"
          native-type="submit"
          @click="onSubmit">
          登录
        </van-button>
      </div>
    </div>
    <div class="tips-info">
      <div>敬请留意：</div>
      <div> 本应用程序中的内容主要来源于外部渠道（包括但不限于: 投资机构信息、被投公司信息、相关新闻、市场情报等），其著作权归属于原作者；及内部信息收集（如：PwC关系及其涉及的个人信息等）。所有的内容和数据仅供普华永道员工内部参考和学习使用，请勿向普华永道以外的任何人转移、分发或以其他方式分享这些内容和数据 。
      </div>
      <div style="padding-top: 10px;"> 其中，“市场情报”或“market intelligence”栏目的市场讯息均来源于公开新闻或外部数据库，交易线索（包含出售和购买）的真实性尚未得到直接确认，仅供普华永道员工开拓潜在业务机会时作一般了解和适当试用，我们对其真实性不承担任何责任。如有需要，建议您与所涉及的机构/公司/股东先取得联系。
      </div>
      <div style="padding-top: 10px;">感谢您的配合。</div>
    </div>
  </div>
</template>

<script>
import webService from "@/network/webService";
import _ from "lodash";
import { Toast } from "vant";
import { Dialog } from 'vant';
export default {
  name: "login",
  components: {
    Toast,
  },
  data () {
    return {
      loginInfo: {
        userName: '',
        password: '',
      },
      versionKey: 'versionInfo',
    }
  },
  created () {
  },
  mounted () {
    this.checkVersion();
  },
  methods: {
    onSubmit: function () {
      if (this.valudateBeforeSubmit()) {
        webService.login(this.loginInfo).then((res) => {
          if (res && res.data.isSuccess) {
            this.$router.push({
              path: "/home/overview",
            });
          } else {
            this.$toast.fail(res.data.message);
          }
        });
      }

    },
    valudateBeforeSubmit () {
      var isOk = true;
      if (_.trim(this.loginInfo.userName) == "") {
        this.$refs.username.setAttribute("class", "input-style change");
        isOk = false;
      }
      if (_.trim(this.loginInfo.password) == "") {
        this.$refs.password.setAttribute("class", "input-style change");
        isOk = false;
      }
      return isOk;
    },
    checkVersion () {
      var that = this;
      webService.getKeyValueList().then(res => {
        if (res.data) {
          let versionInfo = _.find(res.data, ["configKey", this.versionKey]);
          if (versionInfo) {

            jsBridge.appInfo(function (info) {
              if (info && info.appVer) {
                //判断版本号是否需要更新
                let localVersion = parseInt(info.appVer);
                let latestVersion = parseInt(versionInfo.configValue);
                //alert("当前版本：" + localVersion);
                //alert("最新版本：" + latestVersion);
                if (latestVersion > localVersion) {
                  that.$dialog.alert({
                    message: '版本已更新，请下载最新版本',
                  }).then(() => {
                    that.updateScan();
                  });
                }
              }
            });

          }
        }
      });
    },
    updateScan () {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      let isWeixin = u.indexOf('micromessenger') != -1 || u.indexOf('MicroMessenger') != -1; // 微信浏览器
      //根据实际上pwc mobileappsuat的版本为准
      //1.1.2
      let iosDownloadUrl = "https://mobileappsuat.pwchk.com/MobileAppsManage/Packages/20211109184208014/index.html";
      let androidDownLoadUrl = "https://mobileappsuat.pwchk.com/MobileAppsManage/Packages/20211109110423851/android.apk";
      if (isIOS) {
        jsBridge.openInBrowser(iosDownloadUrl);
      }
      else {
        if (isWeixin) {
          dialog.style.display = 'block';
        } else {
          jsBridge.openInBrowser(androidDownLoadUrl);
        }
      }
    }

  }
};
</script>
  
<style lang="scss" scoped>
.login-info {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
}
.title {
  color: #2d2d2d;
  font-size: 26px;
  padding: 30px 12px 10px 12px;
}
.input-style {
  border: none;
  border-bottom: 1px solid #dedede;
}
.line-info {
  padding: 10px 0;
}
input::-webkit-input-placeholder {
  font-size: 14px;
  color: #bebebe;
}
input:-ms-input-placeholder {
  font-size: 14px;
  color: #bebebe;
}
.change::-webkit-input-placeholder {
  color: #c52a1a;
}
.input-style {
  font-weight: bold;
  border: none;
  border-bottom: 1px solid #dedede;
}
.type-left {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  flex: none;
  box-sizing: border-box;
  width: 24rem;
  color: #2d2d2d;
  text-align: left;
  padding-left: 16px;
  padding-top: 10px;
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  padding-bottom: 5px;
}
.type-right {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  color: #969799;
  text-align: right;
  margin-left: 12px;
}
.must-label {
  margin-right: 10px;
}
.must-input {
  margin-left: -8px;
  color: #c52a1a;
  font-size: 14px;
  margin-top: 2px;
}
.submit-button {
  margin: 20px;
}
.tips-info {
  border: none;
  border-top: 1px solid #dedede;
  padding: 10px 12px;
  font-size: 12px;
  color: #7d7d7d;
}
/deep/ .van-button--round {
  border-radius: 1px;
}
/deep/ .van-button--info {
  background-color: #c52a1a;
  border: 1px solid #c52a1a;
}
</style>


// WEBPACK FOOTER //
// src/views/login/Login.vue